<div class="container">
  <div class="card mt-5 col-12">
    <nav class="card-header navbar navbar-expand-lg custom-navbar">
      <h1 class="col-lg-5">Administrador de usuarios</h1>
      <button
        class="navbar-toggler col-12"
        planType="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse my-3" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item d-flex flex-column flex-lg-row">
            <button
              class="nav-item btn-custom m-1"
              (click)="openExerciseListModal()"
              aria-current="page"
            >
              Ejercicios
            </button>
            <button
              class="nav-item btn-custom m-1"
              (click)="openTutorialsModal()"
              aria-current="page"
            >
              Tutoriales
            </button>
            <button
              class="nav-item btn-custom m-1"
              (click)="openFoodsModal()"
              aria-current="page"
            >
              Comidas
            </button>
            <button
              class="nav-item btn btn-danger m-1"
              aria-current="page"
              (click)="logout()"
            >
              Cerrar Sesión
            </button>
          </li>
        </ul>
      </div>
    </nav>
    <div class="card-body">
      <div class="row d-flex flex-row">
        <div class="col-5">
          <div class="input-group">
            <input
              planType="text"
              [formControl]="searchBar"
              (input)="manageInputFilter()"
              class="form-control"
              placeholder="Busca por nombre o dni"
            />
          </div>
          <span class="mb-3">Buscando por {{ searchSelected }}</span>
        </div>

        <select
          class="form-select select-small me-2"
          aria-label="Small select example"
          (change)="manageSelectFilter('plan', $event)"
          [formControl]="planType"
        >
          <option [value]="null" selected>Tipo de plan</option>
          <option *ngFor="let plan of plans" [value]="plan.type">
            {{ plan.name }}
          </option>
        </select>

        <select
          class="form-select select-small"
          aria-label="Small select example"
          (change)="manageSelectFilter('statusPlanFilter', $event)"
          [formControl]="planStatus"
        >
          >
          <option [value]="null" selected>Estado de plan</option>
          <option value="REQUIRED_FORM">
            Falta formulario de introducción
          </option>
          <option value="REQUIRED_TRAINER_OR_NUTRISIONIST">
            Falta entrenador y/o nutricionista
          </option>
          <option value="STARTED">Empezado</option>
          <option value="FINISHED">Finalizado</option>
        </select>
      </div>

      <table class="table table-hover" *ngIf="users && !isMobile">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Plan Activo</th>
            <th scope="col">Estado del Plan</th>
            <th scope="col">Próximos Vencimientos</th>
            <th scope="col">Seguimiento</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users" (click)="openConfigModal(user)">
            <td>{{ user.firstName }} {{ user.lastName }}</td>
            <td class="">
              <div *ngIf="user.activePlan" style="margin: 0; padding: 0">
                <span
                  *ngIf="user.activePlan.planType == 'GYM'"
                  class="badge rounded-pill text-bg-primary col-12"
                >
                  Entreno en Fit Factory</span
                >

                <span
                  *ngIf="user.activePlan.planType == 'BASIC'"
                  class="badge rounded-pill text-bg-info col-12"
                >
                  Mi rutina del mes</span
                >

                <span
                  *ngIf="user.activePlan.planType == 'GYM_NUTRITION'"
                  class="badge rounded-pill text-bg-primary col-12"
                >
                  GYM (Rutina y alimentación)</span
                >

                <span
                  *ngIf="user.activePlan.planType == 'REGULAR'"
                  class="badge rounded-pill text-bg-primary col-12"
                >
                  Platino</span
                >

                <span
                  *ngIf="user.activePlan.planType == 'PREMIUM'"
                  class="badge rounded-pill text-bg-warning col-12"
                >
                  Premium</span
                >
              </div>
              <div *ngIf="!user.activePlan" style="margin: 0; padding: 0">
                <span class="badge rounded-pill text-bg-secondary col-12"
                  >Sin Plan</span
                >
              </div>
              <div *ngIf="user.newUser" style="margin: 0; padding: 0">
                <span class="badge rounded-pill text-bg-danger col-12"
                  >¡Nuevo! 🔔</span
                >
              </div>
            </td>
            <td>
              <div *ngIf="user.activePlan">
                <span>{{ user.activePlan.status }}</span>
              </div>
              <div *ngIf="!user.activePlan">
                <span> -- </span>
              </div>
            </td>
            <td>
              <strong>Ru: </strong>
              <span *ngIf="user.activeRoutineGroupWeeksToExpire">{{
                user.activeRoutineGroupWeeksToExpire
              }}</span>

              <span *ngIf="!user.activeRoutineGroup"> -- </span>

              <strong class="ms-1">Al: </strong>
              <span *ngIf="user.activeDietWeeksToExpire">{{
                user.activeDietWeeksToExpire
              }}</span>

              <span *ngIf="!user.activeDiet"> -- </span>

              <strong class="ms-1">Plan: </strong>
              <span *ngIf="!undefinedFinishPlan(user) && !infinitePlan(user)">{{
                user.activePlanWeeksToExpire
              }}</span>

              <span
                *ngIf="
                  user.activePlanDaysToExpire &&
                  user.activePlanDaysToExpire < 0 &&
                  user.activePlan &&
                  user.activePlan.finishAt.Valid!
                "
                >V</span
              >

              <span *ngIf="undefinedFinishPlan(user)"> -- </span>

              <span *ngIf="infinitePlan(user)"> Sin vencimiento </span>
            </td>
            <td>
              <div class="d-flex justify-content-arround">
                <button
                  class="btn-custom me-2 position-relative"
                  [routerLink]="['/routines/', user.id]"
                  (click)="selectUser(user, $event, 'rutinas')"
                >
                  Rutinas
                  <span
                    *ngIf="user.activePlan?.routineIsPending"
                    class="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-danger"
                  >
                    Pendiente
                    <span class="visually-hidden">unread messages</span>
                  </span>
                </button>
                <button
                  class="btn-custom position-relative"
                  [routerLink]="['/diet-history/', user.id]"
                  (click)="selectUser(user, $event)"
                >
                  Alimentación
                  <span
                    *ngIf="user.activePlan?.dietIsPending"
                    class="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-danger"
                  >
                    Pendiente
                    <span class="visually-hidden">unread messages</span>
                  </span>
                </button>
              </div>
            </td>
            <td>
              <i
                class="bi bi-gear config-gear"
                data-bs-toggle="modal"
                data-bs-target="#userConfigModal"
                (click)="selectUser(user, $event)"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-hover" *ngIf="users && isMobile">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users">
            <td
              data-bs-toggle="modal"
              data-bs-target="#userInfoModal"
              (click)="selectUser(user, $event)"
            >
              {{ user.firstName }} {{ user.lastName }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-user-info-modal [user]="selectedUser"></app-user-info-modal>
<app-exercise-form-modal
  [(editing)]="editingForm"
  [exercise]="selectedExercise"
></app-exercise-form-modal>

<app-food-list-modal></app-food-list-modal>
<app-food-form-modal></app-food-form-modal>

<app-exercise-list-modal
  (changeEditing)="onEditChange($event)"
></app-exercise-list-modal>
<app-tutorials-form-modal></app-tutorials-form-modal>

<app-tutorials></app-tutorials>
<app-complete-tutorial-form></app-complete-tutorial-form>

<app-user-config-modal [user]="selectedUser"></app-user-config-modal>
<app-plan-create-modal></app-plan-create-modal>
